// Auto-generated from maps/risk/simple/map-config.json
export const MAP_CONFIG = {
  "territories": [
    {
      "id": 0,
      "name": "North Island",
      "shape": [
        {
          "x": 100,
          "y": 50
        },
        {
          "x": 180,
          "y": 60
        },
        {
          "x": 170,
          "y": 120
        },
        {
          "x": 90,
          "y": 110
        },
        {
          "x": 80,
          "y": 80
        }
      ],
      "midpoint": {
        "x": 125,
        "y": 85
      },
      "capturable": true,
      "tiletype": "Standard",
      "adjacent": [
        1,
        2
      ]
    },
    {
      "id": 1,
      "name": "East Coast",
      "shape": [
        {
          "x": 180,
          "y": 60
        },
        {
          "x": 250,
          "y": 70
        },
        {
          "x": 240,
          "y": 140
        },
        {
          "x": 170,
          "y": 120
        }
      ],
      "midpoint": {
        "x": 210,
        "y": 100
      },
      "capturable": true,
      "tiletype": "Standard",
      "adjacent": [
        0,
        3,
        5
      ]
    },
    {
      "id": 2,
      "name": "Central Valley",
      "shape": [
        {
          "x": 90,
          "y": 110
        },
        {
          "x": 170,
          "y": 120
        },
        {
          "x": 160,
          "y": 180
        },
        {
          "x": 100,
          "y": 170
        },
        {
          "x": 70,
          "y": 140
        }
      ],
      "midpoint": {
        "x": 120,
        "y": 145
      },
      "capturable": true,
      "tiletype": "Standard",
      "adjacent": [
        0,
        3,
        4
      ]
    },
    {
      "id": 3,
      "name": "Mountain Pass",
      "shape": [
        {
          "x": 170,
          "y": 120
        },
        {
          "x": 240,
          "y": 140
        },
        {
          "x": 230,
          "y": 200
        },
        {
          "x": 160,
          "y": 180
        }
      ],
      "midpoint": {
        "x": 200,
        "y": 160
      },
      "capturable": true,
      "tiletype": "Standard",
      "adjacent": [
        1,
        2,
        4
      ]
    },
    {
      "id": 4,
      "name": "South Harbor",
      "shape": [
        {
          "x": 100,
          "y": 170
        },
        {
          "x": 160,
          "y": 180
        },
        {
          "x": 150,
          "y": 240
        },
        {
          "x": 80,
          "y": 230
        },
        {
          "x": 70,
          "y": 200
        }
      ],
      "midpoint": {
        "x": 115,
        "y": 205
      },
      "capturable": true,
      "tiletype": "Standard",
      "adjacent": [
        2,
        3,
        5
      ]
    },
    {
      "id": 5,
      "name": "Southeast Island",
      "shape": [
        {
          "x": 240,
          "y": 200
        },
        {
          "x": 290,
          "y": 210
        },
        {
          "x": 280,
          "y": 260
        },
        {
          "x": 230,
          "y": 250
        },
        {
          "x": 220,
          "y": 225
        }
      ],
      "midpoint": {
        "x": 255,
        "y": 230
      },
      "capturable": true,
      "tiletype": "Standard",
      "adjacent": [
        1,
        4
      ]
    }
  ],
  "adjacencies": [
    {
      "from": 0,
      "to": 1,
      "connectionType": "land_border",
      "visualLines": [
        {
          "from": {
            "x": 147,
            "y": 90
          },
          "to": {
            "x": 188,
            "y": 95
          }
        }
      ]
    },
    {
      "from": 0,
      "to": 2,
      "connectionType": "land_border",
      "visualLines": [
        {
          "from": {
            "x": 123,
            "y": 105
          },
          "to": {
            "x": 121,
            "y": 125
          }
        }
      ]
    },
    {
      "from": 1,
      "to": 3,
      "connectionType": "land_border",
      "visualLines": [
        {
          "from": {
            "x": 206,
            "y": 120
          },
          "to": {
            "x": 204,
            "y": 140
          }
        }
      ]
    },
    {
      "from": 2,
      "to": 3,
      "connectionType": "land_border",
      "visualLines": [
        {
          "from": {
            "x": 140,
            "y": 150
          },
          "to": {
            "x": 180,
            "y": 155
          }
        }
      ]
    },
    {
      "from": 2,
      "to": 4,
      "connectionType": "land_border",
      "visualLines": [
        {
          "from": {
            "x": 118,
            "y": 165
          },
          "to": {
            "x": 117,
            "y": 185
          }
        }
      ]
    },
    {
      "from": 3,
      "to": 4,
      "connectionType": "land_border",
      "visualLines": [
        {
          "from": {
            "x": 180,
            "y": 175
          },
          "to": {
            "x": 135,
            "y": 190
          }
        }
      ]
    },
    {
      "from": 1,
      "to": 5,
      "connectionType": "ocean_crossing",
      "visualLines": [
        {
          "from": {
            "x": 225,
            "y": 125
          },
          "to": {
            "x": 240,
            "y": 205
          }
        }
      ]
    },
    {
      "from": 4,
      "to": 5,
      "connectionType": "ocean_crossing",
      "visualLines": [
        {
          "from": {
            "x": 135,
            "y": 215
          },
          "to": {
            "x": 235,
            "y": 220
          }
        }
      ]
    }
  ],
  "mapSettings": {
    "mapWidth": 350,
    "mapHeight": 320,
    "viewBoxX": 50,
    "viewBoxY": 30,
    "viewBoxWidth": 260,
    "viewBoxHeight": 260
  }
};

export const TERRITORY_COORDINATES = {
  0: {"x":125,"y":85},
  1: {"x":210,"y":100},
  2: {"x":120,"y":145},
  3: {"x":200,"y":160},
  4: {"x":115,"y":205},
  5: {"x":255,"y":230}
};

export const TERRITORY_SHAPES = {
  0: [{"x":100,"y":50},{"x":180,"y":60},{"x":170,"y":120},{"x":90,"y":110},{"x":80,"y":80}],
  1: [{"x":180,"y":60},{"x":250,"y":70},{"x":240,"y":140},{"x":170,"y":120}],
  2: [{"x":90,"y":110},{"x":170,"y":120},{"x":160,"y":180},{"x":100,"y":170},{"x":70,"y":140}],
  3: [{"x":170,"y":120},{"x":240,"y":140},{"x":230,"y":200},{"x":160,"y":180}],
  4: [{"x":100,"y":170},{"x":160,"y":180},{"x":150,"y":240},{"x":80,"y":230},{"x":70,"y":200}],
  5: [{"x":240,"y":200},{"x":290,"y":210},{"x":280,"y":260},{"x":230,"y":250},{"x":220,"y":225}]
};

export const ADJACENCIES = {
  0: [1, 2],
  1: [0, 3, 5],
  2: [0, 3, 4],
  3: [1, 2, 4],
  4: [2, 3, 5],
  5: [1, 4]
};

export const CONNECTION_LINES = {
  "0-1": { connectionType: "land_border", visualLines: [{"from":{"x":147,"y":90},"to":{"x":188,"y":95}}] },
  "0-2": { connectionType: "land_border", visualLines: [{"from":{"x":123,"y":105},"to":{"x":121,"y":125}}] },
  "1-3": { connectionType: "land_border", visualLines: [{"from":{"x":206,"y":120},"to":{"x":204,"y":140}}] },
  "2-3": { connectionType: "land_border", visualLines: [{"from":{"x":140,"y":150},"to":{"x":180,"y":155}}] },
  "2-4": { connectionType: "land_border", visualLines: [{"from":{"x":118,"y":165},"to":{"x":117,"y":185}}] },
  "3-4": { connectionType: "land_border", visualLines: [{"from":{"x":180,"y":175},"to":{"x":135,"y":190}}] },
  "1-5": { connectionType: "ocean_crossing", visualLines: [{"from":{"x":225,"y":125},"to":{"x":240,"y":205}}] },
  "4-5": { connectionType: "ocean_crossing", visualLines: [{"from":{"x":135,"y":215},"to":{"x":235,"y":220}}] }
};

export const MAP_SETTINGS = {
  "mapWidth": 350,
  "mapHeight": 320,
  "viewBoxX": 50,
  "viewBoxY": 30,
  "viewBoxWidth": 260,
  "viewBoxHeight": 260
};

// Vector-based polygon utilities 
export function getPolygonPath(shape) {
  if (!shape || shape.length === 0) return '';
  return shape.map(point => `${point.x},${point.y}`).join(' ');
}

export function getTerritoryMidpoint(territoryId) {
  return TERRITORY_COORDINATES[territoryId] || { x: 0, y: 0 };
}

export function getTerritoryShape(territoryId) {
  return TERRITORY_SHAPES[territoryId] || [];
}

export function getTerritoryName(index) {
  const territory = MAP_CONFIG.territories.find(t => t.id === index);
  return territory ? territory.name : `Territory ${index}`;
}

export function getCapturableTerritoryCount() {
  return MAP_CONFIG.territories.filter(t => t.capturable !== false).length;
}

export function getAllTerritoryIds() {
  return MAP_CONFIG.territories.map(t => t.id);
}

export function isValidTarget(sourceIndex, targetIndex) {
  return ADJACENCIES[sourceIndex] && ADJACENCIES[sourceIndex].includes(targetIndex);
}

export function getConnectionLine(fromId, toId) {
  const key1 = `${fromId}-${toId}`;
  const key2 = `${toId}-${fromId}`;
  return CONNECTION_LINES[key1] || CONNECTION_LINES[key2] || null;
}

// Point-in-polygon test for territory selection
export function isPointInPolygon(point, polygon) {
  if (!polygon || polygon.length < 3) return false;
  
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i].x, yi = polygon[i].y;
    const xj = polygon[j].x, yj = polygon[j].y;
    
    if (((yi > point.y) !== (yj > point.y)) && (point.x < (xj - xi) * (point.y - yi) / (yj - yi) + xi)) {
      inside = !inside;
    }
  }
  
  return inside;
}
